var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: "800px",
    height: "800px",
    viewBox: "-1 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 15.32a1.026 1.026 0 0 1-.727-.302L8.5 8.946l-6.073 6.072a1.03 1.03 0 0 1-1.456-1.455l6.801-6.8a1.03 1.03 0 0 1 1.456 0l6.8 6.8a1.03 1.03 0 0 1-.727 1.757z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpSvgrepoCom);
export default __webpack_public_path__ + "static/media/chevron-up-svgrepo-com.c27f8cfc2bf792715c2b48a8a4ca273a.svg";
export { ForwardRef as ReactComponent };